module.exports = import("https://esm.sh/@tiptap/extension-image@2.4.0");;